// extracted by mini-css-extract-plugin
export var addToCartButton = "_sa-b";
export var arrowButtonContainer = "_sa-9";
export var arrowButtonIcon = "_sa-a";
export var carouselArrowButton = "_sa-6";
export var carouselElementContainer = "_sa-1";
export var galleryThumbnail = "_sa-d";
export var galleryThumbnailImage = "_sa-e";
export var left = "_sa-7";
export var productDisplayCarouselContainer = "_sa-0";
export var productTileContainer = "_sa-2";
export var productTileImage = "_sa-4";
export var productTileImageContainer = "_sa-3";
export var productTileTitle = "_sa-5";
export var right = "_sa-8";
export var sliderOverflow = "_sa-c";